<template>
	<div>
		<div class="actDiv">
			<label style="margin-left:0.625rem ;">小区</label>
			<a-select  style="width:24rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="可多选" label-in-value
						    option-filter-prop="children"  :filter-option="filterOption" show-search  mode="multiple">
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			<label>用量区间</label>
			<a-input-number v-model="startAmount" size="small" style="width: 5rem;margin: 0 0.625rem ;"/>
			<label>-</label>
			<a-input-number v-model="endAmount" size="small" style="width: 5rem;margin: 0 0.625rem ;"/>
			<label style="font-size: 0.8rem;">时间范围：</label>
			<a-range-picker   style="font-size: 0.6875rem;width: 15rem;" format="YYYY-MM-DD" @change="onChangeDate" size="small" show-time>
			</a-range-picker>
			<a-button size="small"   icon="search" @click="doQuery()" style="margin: 0 0.425rem;">查询</a-button>
			<a-button size="small"   icon="download" @click="exportData()" style="margin: 0 0.425rem;" :loading="exporting">导出</a-button>
		</div>
		<vxe-table  align="center" :data="list"  border max-height="400"   ref="mTable"  sort-type="number"
						  resizable highlight-hover-row :loading="loading"   size="mini" >
				<vxe-table-column type="seq" width="50"></vxe-table-column>
				<vxe-table-column title="小区名称" field="neighborId" width="110"  :formatter="getTheNeighborName"></vxe-table-column>
				<vxe-table-column title="用户号" field="customerNum" width="85"></vxe-table-column>
				<vxe-table-column title="立户号" field="aPID" width="90"></vxe-table-column>
				<vxe-table-column title="表地址" field="meterAddr"></vxe-table-column>
				<vxe-table-column title="上次抄表时间" field="ActionTime" :formatter="getTimeFormatter"></vxe-table-column>
				<vxe-table-column title="本次抄表时间" field="readtime" :formatter="getTimeFormatter"></vxe-table-column>
				<vxe-table-column title="上次抄表读数" field="ActionResult"></vxe-table-column>
				<vxe-table-column title="本次抄表读数" field="readdata"></vxe-table-column>
				<vxe-table-column title="最新用水量" field="waterCount"  sortable></vxe-table-column>
				<vxe-table-column title="操作" field="PID">
					<template #default="{ row }">
						<a-button   size="small"  type="link"  @click="showHistoryData(row)">历史用水量</a-button>
					</template>
				</vxe-table-column>
		</vxe-table>
		<div id="myCharts"></div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	export default {
		data(){
			return {
				theNeighbor:undefined,
				neighborList:[],
				dataList:[],
				list:[],
				loading:false,
				myChart:null,
				theMonth:6,
				startAmount:null,
				endAmount:null,
				exporting:false,
				dateStart:null,
				dateEnd:null,
			}
		},
		methods:{
			onChangeDate(date, dateString) {
				this.dateStart=dateString[0];
				this.dateEnd=dateString[1];
			},
			exportData(){
				this.exporting = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_EXPORT_ANALYSE_WH_URL);
				let param =this.getParam();
				this.Api.fetchPostFile(url,param).then((res)=>{
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName ='用水量导出.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
					this.exporting = false;
				}).catch((error)=>{
					this.exporting = false;
					console.log(error);
				});
			},
			getTheNeighborName({cellValue}){
				let result = '';
				for(var i =0 ;i<this.neighborList.length;i++){
					let item = this.neighborList[i];
					if(cellValue == item.pId){
						result = item.neighborName;
						break;
					}
				}
				return result;
			},
			getParam(){
				var neighborIds = '';
				if(this.theNeighbor != undefined && this.theNeighbor != null ){
					var neighborList = [];
					for(var i =0 ;i<this.theNeighbor.length;i++){
						let item = this.theNeighbor[i];
						neighborList.push(item.key);
					}
					neighborIds = neighborList.join(',');
				}
				if(this.startAmount!=null && this.endAmount!=null){
					let temp = this.endAmount;
					if(this.smartAmount>this.endAmount){
						this.endAmount = this.startAmount;
						this.startAmount = temp;
					}
				}
				let param = {
					neighborIds:neighborIds,
					startAmount:this.startAmount,
					endAmount:this.endAmount,
					startDate:this.dateStart,
					endDate:this.dateEnd,
				};
				return param;
			},
			doQuery(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_RESULT_ANALYSE_WH_URL);
				let param =this.getParam();
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			getMeterState({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getMeterStateList());
			},
			getLiHuStatus({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getLiHUList());
			},
			showHistoryData(row){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.GET_METER_USE_COUNT_URL);
				let param = {meterId:row.pId,theMonth:this.theMonth};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.drawEcharts(result);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			drawEcharts(result){
				var xData = [];
				var valueData = [];
				for(var i =0 ;i<result.length;i++){
					var item = result[i];
					xData.push(item.readTime);
					valueData.push(item.useCount);
				}
				var x = "最近"+this.theMonth+"个月的用水量";
				var option = {
					title:{
						text:x
					},
					xAxis:{
						data:xData,
						type:'category'
					},
					yAxis: {
					    type: 'value'
					},
					 tooltip: {
					    trigger: 'axis',
					},
					series: [
					    {
							data: valueData,
							type: 'bar'
					    }
					]
				};
				this.myChart.setOption(option);
			},
		},
		created() {
			this.queryNeighbors();
			
		},
		mounted(){
			var chartDom = document.getElementById('myCharts');
			this.myChart = echarts.init(chartDom);
		}
	}
</script>

<style>
	#myCharts{
		width: 100%;
		height: 18.75rem;
	}
</style>
